angular.module("ainapp")
    .controller("viewStockFOCController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Stock FOC Preview";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {

                $scope.load = true;
                $scope.VoucherData = {};

                if ($stateParams.VoucherId > 0) {
                    MainService.getStockFOCbyId($stateParams.VoucherId).then(function (response) {
                        if (response.data) {
                            $scope.VoucherData = response.data[0];
                        }
                        $scope.load = false;
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("NetworkError");
                    })
                }

            }

            $scope.init();

            $scope.Edit = function () {
                $state.go("editStockFOC", {
                    VoucherId: $stateParams.VoucherId
                })
            };




        }])
